import {
  featureFlagsConstants,
  featureFlagsListConstants,
  featureAvailableGroupsConstants,
  featureGlobalActivateConstants,
  addFeatureTargetGroupsConstants,
} from "../_redux-constants";

export function featureFlagsReducer(
  state = {
    featureFlagsLoading: false,
    featureFlagsData: null,
    featureFlagsError: null,

    featureFlagsListLoading: false,
    featureFlagsListData: null,
    featureFlagsListError: null,

    featureAvailableGroupsLoading: false,
    featureAvailableGroupsData: null,
    featureAvailableGroupsError: null,

    addFeatureTargetGroupsLoading: false,
    addFeatureTargetGroupsData: null,
    addFeatureTargetGroupsError: null,
  },
  action
) {
  switch (action.type) {
    case featureFlagsListConstants.FEATURE_FLAGS_LIST_LOADING:
      return Object.assign({}, state, {
        featureFlagsListLoading: true,
        featureFlagsListData: null,
        featureFlagsListError: null,
      });
    case featureFlagsListConstants.FEATURE_FLAGS_LIST_SUCCESS:
      return Object.assign({}, state, {
        featureFlagsListLoading: false,
        featureFlagsListData: action.data,
      });
    case featureFlagsListConstants.FEATURE_FLAGS_LIST_FAILURE:
      return Object.assign({}, state, {
        featureFlagsListLoading: false,
        featureFlagsListData: null,
        featureFlagsListError: action.error,
      });
    case featureFlagsConstants.FEATURE_FLAGS_LOADING:
      return Object.assign({}, state, {
        featureFlagsLoading: true,
        featureFlagsData: null,
        featureFlagsError: null,
      });
    case featureFlagsConstants.FEATURE_FLAGS_SUCCESS:
      return Object.assign({}, state, {
        featureFlagsLoading: false,
        featureFlagsData: action.data,
      });
    case featureFlagsConstants.FEATURE_FLAGS_FAILURE:
      return Object.assign({}, state, {
        featureFlagsLoading: false,
        featureFlagsData: null,
        featureFlagsError: action.error,
      });
    case featureAvailableGroupsConstants.FEATURE_AVAILABLE_GROUPS_LOADING:
      return Object.assign({}, state, {
        featureAvailableGroupsLoading: true,
        featureAvailableGroupsData: null,
        featureAvailableGroupsError: null,
      });
    case featureAvailableGroupsConstants.FEATURE_AVAILABLE_GROUPS_SUCCESS:
      return Object.assign({}, state, {
        featureAvailableGroupsLoading: false,
        featureAvailableGroupsData: action.data,
      });
    case featureAvailableGroupsConstants.FEATURE_AVAILABLE_GROUPS_FAILURE:
      return Object.assign({}, state, {
        featureAvailableGroupsLoading: false,
        featureAvailableGroupsData: null,
        featureAvailableGroupsError: action.error,
      });
    case featureGlobalActivateConstants.FEATURE_GLOBAL_ACTIVATE_LOADING:
      return Object.assign({}, state, {
        featureGlobalActivateLoading: true,
        featureGlobalActivatesData: null,
        featureGlobalActivateError: null,
      });
    case featureGlobalActivateConstants.FEATURE_GLOBAL_ACTIVATE_SUCCESS:
      return Object.assign({}, state, {
        featureGlobalActivateLoading: false,
        featureGlobalActivateData: action.data,
      });
    case featureGlobalActivateConstants.FEATURE_GLOBAL_ACTIVATE_FAILURE:
      return Object.assign({}, state, {
        featureGlobalActivateLoading: false,
        featureGlobalActivateData: null,
        featureGlobalActivateError: action.error,
      });
    case addFeatureTargetGroupsConstants.ADD_FEATURE_TARGET_GROUPS_LOADING:
      return Object.assign({}, state, {
        addFeatureTargetGroupsLoading: true,
        addFeatureTargetGroupsData: null,
        addFeatureTargetGroupsError: null,
      });
    case addFeatureTargetGroupsConstants.ADD_FEATURE_TARGET_GROUPS_SUCCESS:
      return Object.assign({}, state, {
        addFeatureTargetGroupsLoading: false,
        addFeatureTargetGroupsData: action.data,
      });
    case addFeatureTargetGroupsConstants.ADD_FEATURE_TARGET_GROUPS_FAILURE:
      return Object.assign({}, state, {
        addFeatureTargetGroupsLoading: false,
        addFeatureTargetGroupsData: null,
        addFeatureTargetGroupsError: action.error,
      });

    default:
      return state;
  }
}
